export const sensorTypeLabelPadding = '17px 0 0 0';

export const selectTemperatureSensorP891 = (selectedTag, formName, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F573TemperatureSensorTypeLabel',
                    label: 'Temperature Sensor Type',
                    xs: 4,
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                    padding: sensorTypeLabelPadding
                },
                {
                    key: 'F573TemperatureSensorType',
                    value: formData.F573TemperatureSensorType,
                    isDropdown: true,
                    placeholder: 'Select from list',
                    options: [{ name: 'Select from list', value: '' },
                    { name: 'RTD', value: 'RTD' },
                    { name: 'Thermocouple', value: 'Thermocouple' }],
                    inputTextAlign: 'center',
                    isRequired: true,
                    labelWidth: '0',
                    width: '100%',
                    xs: 2,
                    marginTop: '14px'
                }
            ]
        }
    ]
});

export const selectSensorP734 = (selectedTag, formName, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F1051SpeedSensorTypeLabel',
                label: 'Sensor Type',
                xs: 4,
                isLabel: true,
                fontWeight: '600',
                fontSize: '9pt',
                padding: sensorTypeLabelPadding
            },
            {
                key: 'F1051SpeedSensorType',
                value: formData.F1051SpeedSensorType,
                isDropdown: true,
                placeholder: 'Select Sensor Type',
                options: [{ name: 'Select Sensor Type', value: '' },
                { name: 'Electronic', value: 'Electronic' },
                { name: 'Magnetic', value: 'Magnetic' },
                { name: 'Proximity', value: 'Proximity' }],
                inputTextAlign: 'center',
                isRequired: true,
                labelWidth: '0',
                width: '100%',
                xs: 2,
                marginTop: '14px'
            },
            {
                key: 'SensorResistanceLabel',
                label: 'Sensor Resistance (Ω)',
                xs: 4,
                isLabel: true,
                labelWidth: '98%',
                fontWeight: '600',
                fontSize: '9pt',
                padding: sensorTypeLabelPadding,
                direction: 'rtl',
                marginRight: '0.5rem',
                textAlign: 'right'
            },
            {
                key: 'F1053SensorResistance',
                value: formData.F1053SensorResistance,
                xs: 2,
                type: 'number',
                maxLength: '10',
                labelWidth: '0%',
                width: '100%',
                height: '1.2rem',
                textAlign: 'center',
                marginTop: '14px'

            }]
        }
    ]
});

export const selectTemperatureSensor = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if (['P8-9.1', 'P7-19'].includes(formName)) {
        filterViewData = selectTemperatureSensorP891(selectedTag, formName, formData);
    } else if (['P7-34'].includes(formName)) {
        filterViewData = selectSensorP734(selectedTag, formName, formData);
    }
    return filterViewData;
};
